import { Banner } from './Banner';
import styles from './Banner.module.scss';
import { BannerGroupProps } from './BannerProps';

import type { FC } from 'react';

export const BannerGroup: FC<BannerGroupProps> = ({ bannerPropsList }) => (
  <>
    {bannerPropsList.map((bannerProps) => (
      <div className={styles['wrap-banner']} key={bannerProps.id}>
        <Banner
          id={bannerProps.id}
          bannerUrl={bannerProps.bannerUrl}
          contentUrl={bannerProps.contentUrl}
          altText={bannerProps.altText}
          customDataAttrGtmClick={bannerProps.customDataAttrGtmClick}
        />
      </div>
    ))}
  </>
);
